import { Notification } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '..';

import * as Types from './types';

const { ActionTypes } = Types;

export const GetAccountNotificatins = (): Types.GetAccountNotificatinsAction => ({
    type: ActionTypes.GET_ACC_NOTIFICATIONS,
});

export const UpdateAccountNotificaitons = (
    notificationList: Notification[],
    isLoading = false
): Types.UpdateNotificationStoreAction => ({
    type: ActionTypes.UPDATE_NOTIFICATIONS,
    payload: {
        isLoading,
        notificationList,
    },
});

export const NotificationError = (): Types.NotificationErrorAction => ({
    type: ActionTypes.NOTIFICATION_ERROR,
});

export const getNotificationStore = (store: ApplicationState): Types.NotificationStore => store.notification;
